module.exports = __webpack_public_path__ + "static/media/roof-9-tesla-solar.06663d3a.jpeg";